import React from "react";
import { observer, inject } from "mobx-react";
//import Slider from "react-slick";
import InnerImageZoom from "@components/InnerImageZoom/InnerImageZoom";
import ImageGallery from 'react-image-gallery';

@inject("store")
@observer
export default class IComImageSlider extends React.Component {
    constructor(props) {
        super(props);

        this.containerRef = React.createRef();

        this.state = {
            firstClientX: 0,
            firstClientY: 0
        }
        this.preventTouch = this.preventTouch.bind(this);
        this.touchStart = this.touchStart.bind(this);

        this.renderItem = this.renderItem.bind(this);
    }

    preventTouch = function (e) {
        const minValue = 5; // threshold
        let clientX = e.touches[0].clientX - this.state.firstClientX;
        let clientY = e.touches[0].clientY - this.state.firstClientY;

        if (clientX < 0) {
            clientX = clientX * (-1);
        }

        // Vertical scrolling does not work when you start swiping horizontally.
        if (Math.abs(clientX) > minValue) {
            e.preventDefault();
            e.returnValue = false;

            return false;
        }
    }

    touchStart = function (e) {
        this.setState({ firstClientX: e.touches[0].clientX, firstClientY: e.touches[0].clientY });
    }



    renderItem(image) {
        //console.log("renderItem", image);
        var navigation = this.props.store.navigation;
        var zoomUrl = image.original.indexOf("?") > -1
            ? image.original.split("?")[0]
            : image.original;
        zoomUrl += "?format=jpg&quality=80&width=1600";


        return (<div className='image-gallery-image '>
               <InnerImageZoom src={image.original} zoomSrc={zoomUrl} fullscreenOnMobile={true} alt={image.alt}/>
               {/*<InnerImageZoom src={image.original.cropUrl} zoomSrc={image.original.cropUrl.split("?")[0] + "?format=webp&bgcolor=f6f6f6&quality=80&width=1600"} fullscreenOnMobile={true} />
               <InnerImageZoom src={image.original.cropUrl} zoomSrc={image.original.cropUrl} fullscreenOnMobile={true} />*/}
        </div>);
    }



    render() {
        //console.log("images", this.props.images);
        return (
            <div ref={this.containerRef}>
                <ImageGallery items={this.props.images}
                    showFullscreenButton={this.props.showFullscreenButton ? this.props.showFullscreenButton : false}
                    thumbnailPosition={this.props.thumbnailPosition ? this.props.thumbnailPosition : "left"}
                    renderItem={this.renderItem}
                    showThumbnails={this.props.showThumbnails ? this.props.showThumbnails : false}
                    infinite={this.props.infinite ? this.props.infinite : false}
                    showNav={this.props.showNav ? this.props.showNav : false}
                    showBullets={this.props.showBullets ? this.props.showBullets : false}
                    useBrowserFullscreen={false}
                    showPlayButton={false}
                    disableArrowKeys={true}
                    startIndex={this.props.startIndex ? this.props.startIndex : 0}
                />
            {/*
                <Slider {...this.props.sliderSettings}>
                    {this.props.images.map((image) => {
                        return (<div key={image.original}>
                            <InnerImageZoom src={image.original.cropUrl} zoomSrc={image.original.cropUrl} fullscreenOnMobile={true} />
                        </div>);
                    })} 
                </Slider>*/}
            </div>
        );
    }
}